export class AddTypeBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  statusLid: string;
  statusName: string;
  typeName: string;
  typeNumber: any;
  typeFor: string;
}

export class GetListBasetype {
  currentpageno: number = 1;
  pageitem: number = 10;
  orderColumn: string = "typeName";
  orderType: string = "asc";
  type: string = "string";
  field: string = "typeName";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
  statusLid: string | null;
}

export class WhereCondition {
  field: string = "typeName";
  value: string = "";
  operator: string = "startswith";
  orderNo: number = 1;
  predicate: string = "and";
  type: string = "string";
  matchCase: boolean = false;
}
// ...........................................notes.........................................................................

export class AddNoteBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  date: string;
  notes: string;
  typeListIds: string[];
  typeListId: string = "00000000-0000-0000-0000-000000000000";
  employeeId: string = "00000000-0000-0000-0000-000000000000";
  agencyId: string = "00000000-0000-0000-0000-000000000000";
  // user: string
  initial: string;
  // multipletype: [];
}

export class GetListBasenote {
  SearchColumn: string = "typeListName";
  SearchText: string = "";
  orderColumn: string = "date";
  orderType: string = "desc";
  pageitem: number = 10;
  currentpageno: number = 1;
  userId: string = "00000000-0000-0000-0000-000000000000";
  field: string = "typeListName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "startswith";
  type: string = "string";
  startDate: string | null;
  endDate: string | null;
  typeListId: string = "00000000-0000-0000-0000-000000000000";
  employeeId: string;
}

export class WhereConditionnote {
  field: string = "notes";
  value: string = "";
  operator: string = "startswith";
  orderNo: number = 1;
  predicate: string = "and";
  type: string = "string";
  matchCase: boolean = false;
}
